import { z } from 'zod';
import { InventoryMovementTypeEnum } from 'src/utils/inventory';

export const movementFormSchema = z
  .object({
    itemId: z.string().min(1),
    type: z.nativeEnum(InventoryMovementTypeEnum),
    quantity: z.preprocess(
      (a) => parseFloat(`${a}`),
      z.number().refine((v) => v !== 0, 'Quantity cannot be zero')
    ),
    note: z.string().optional(),
    date: z.any(),
  })
  .superRefine((values, ctx) => {
    const positiveOnly = values.type !== InventoryMovementTypeEnum.ADJUST;
    if (positiveOnly && values.quantity <= 0) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['quantity'], message: 'Quantity must be positive' });
    }
    if (values.type === InventoryMovementTypeEnum.ADJUST && (!values.note || values.note.trim() === '')) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['note'], message: 'Note is required for adjustments' });
    }
  });
